import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class QuadbinCenter extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.quadbincenter',
        group: 'Spatial Indexes',
        title: 'Quadbin Center',
        description: `
      This component adds a new column containing the centers of Quadbin cells.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'quadbincol',
          type: WorkflowComponentParamType.Column,
          title: 'Quadbin column',
          parent: 'source',
          placeholder: 'quadbin',
          dataType: [ColumnDataType.Number]
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return `SELECT /*+ REPARTITION(40, geom) */
                *,
                ${connection.processOutputGeogColumn(`ST_GEOMFROMTEXT(QUADBIN_CENTER(
                    ${params.quadbincol}
                ))`)} geom
              FROM ${connection.quoteName(params.source as string)}`
    } else {
      return `SELECT *,
              ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.QUADBIN_CENTER(
                  ${params.quadbincol}
                ) geom
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    return '1.0.0'
  }

  getVersion(provider: Provider) {
    return '1.1'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'geom',
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { QuadbinCenter }
